import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { QuotationFormalityComponent } from '../quotation-formality.component';
import { QuotationFormalityDelete } from '../../../../shared/models/quotation-model/main/quotation-formality-delete.model';
import { QuotationService } from '../../../../shared/services/quotation/quotation.service';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { HybridFormComponent } from '../../../../general-page/hybrid-page/hybrid-form/hybrid-form.component';
import { InputGeneralSelectComponent } from '../../../../shared/inputs/input-general-select/input-general-select.component';
import { InputGeneralTextComponent } from '../../../../shared/inputs/input-general-text/input-general-text.component';
import { InputGeneral } from '../../../../shared/inputs/input-general/input-general';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-confirm-delete',
  templateUrl: './confirm-delete.component.html',
  styleUrls: ['./confirm-delete.component.scss'],
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, TranslateModule, MatButtonModule],
})
export class ConfirmDeleteComponent implements OnInit {
  formalityDelete!: QuotationFormalityDelete;
  constructor(
    public dialogRef: MatDialogRef<QuotationFormalityComponent>,
    @Inject(MAT_DIALOG_DATA) public quotationId: any,
    @Inject(MAT_DIALOG_DATA) public formalityId: any,
    private quotationService: QuotationService,
  ) {}

  ngOnInit() {}

  public deleteFormality(): void {
    this.formalityDelete = {
      quotationId: this.quotationId.quotationId,
      formalityId: this.formalityId.formalityId,
    };
    this.quotationService.deleteFormality(this.formalityDelete).subscribe((response) => {
      this.dialogRef.close();
    });
  }

  public closeModal(): void {
    this.dialogRef.close();
  }
}
